import { UniqueFeatureName } from './types';

const uniqueFeatureNameMap: UniqueFeatureName = {
  contributor_seats: ['contributor_seats', 'advanced_collaboration'],
  response_count: ['base_response_count', 'unlimited_responses', 'num_free_responses'],
  support: ['priority_email_support', 'phone_support', 'email_support'],
  skip_logic: ['create_piping_enabled', 'skip_logic'],
  statistical_significance: ['statistical_significance', 'text_analysis'],
};

export default uniqueFeatureNameMap;
